<template>
	<div class="container">
		<div class="row">
			<div class="form-container">
				<h2 class="title-center header-no-padding-bottom">Registro</h2>
				<div class="col-sm-7 col-sm-offset-2 col-md-5 col-md-offset-3">
					<form class="form-horizontal form-register" id="register" novalidate @submit="RegisterUser">
						<p class="col-sm-9 col-sm-offset-3 legend-custom">Crea tu cuenta
							<span class="span-gray">* campos requeridos</span>
						</p>
						<!-- <register-general :form="form" v-ref:general></register-general> -->
						<div class="form-group">
						    <label class="control-label col-sm-3">Nombre*</label>
						    <div class="col-sm-9">
						      <input class="form-control" :class="{ 'has-error': err.name || err.name_msg }" type="text" v-model="form1.name"/>
						      <div class="tooltip-error" v-if="err.name">
						      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
						      	Ingresa tu nombre para continuar.
						      </div>
						      <div class="tooltip-error" v-if="err.name_msg">
						      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
						      	{{ err.name_msg }}
						      </div>
					    	</div>
					 	</div>
						<div class="form-group">
							<label class="control-label col-sm-3" for="last-name">Apellidos*</label>
							<div class="col-sm-9">
							  <input class="form-control" :class="{ 'has-error': err.last_name || err.last_name_msg}" type="text" v-model="form1.last_name"/>
							  <div class="tooltip-error" v-if="err.last_name">
						      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
						      	Ingresa tu apellido para continuar.
						      </div>
						      <div class="tooltip-error" v-if="err.last_name_msg">
						      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
						      	{{ err.last_name_msg }}
						      </div>
							</div>
						</div>
						<div class="form-group">
							<label class="control-label col-sm-3" for="phone">Teléfono*</label>
							<div class="col-sm-9">
					      		<input class="form-control" :class="{ 'has-error': err.phone || err.phone_msg}" type="text"  v-model="form1.phone"/>
					      		<div class="tooltip-error" v-if="err.phone">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	Ingresa tu número de teléfono para continuar.
						      	</div>
						      	<div class="tooltip-error" v-if="err.phone_msg">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	{{ err.phone_msg }}
							    </div>
							</div>
						</div>
						<div class="form-group">
							<label class="control-label col-sm-3" for="birthday">Fecha de cumpleaños</label>

							<div class="col-sm-4">
								<div class="form-control control-select">
									<select class="select" :class="{ 'has-error': err.month }" id="month" v-model="month" @change="getDays">
										<option value="" selected disabled>mm</option>
									    <option value="1">Enero</option>
									    <option value="2">Febrero</option>
									    <option value="3">Marzo</option>
									    <option value="4">Abril</option>
									    <option value="5">Mayo</option>
									    <option value="6">Junio</option>
									    <option value="7">Julio</option>
									    <option value="8">Agosto</option>
									    <option value="9">Septiembre</option>
									    <option value="10">Octubre</option>
									    <option value="11">Noviembre</option>
									    <option value="12">Diciembre</option>
									</select>
									<i class="fa fa-caret-down select-caret"></i>
								</div>
							</div>

							<label class="control-label col-sm-1 vh" style="padding-left:0; text-align: center">/</label>

							<div class="col-sm-4">
								<div class="form-control control-select">
									<select class="select" :class="{ 'has-error': err.day }" id="day" v-model="day">
										<option value="" selected disabled>dd</option>
									    <option v-for="n in days" :value="n + 1">{{ n + 1 }}</option>
									</select>
									<i class="fa fa-caret-down select-caret"></i>
								</div>
							</div>

							<i class="fa fa-question-circle vh" aria-hidden="true" data-toggle="tooltip" data-placement="right" title="Ingresa tu fecha de cumpleaños para recibir promociones (mm-dd)"></i>
						</div>
						<div class="form-group">
							<label class="control-label col-sm-3" for="email">Email*</label>
							<div class="col-sm-9">
								<input class="form-control" :class="{ 'has-error': err.email || err.email_msg }" type="email" v-model="form1.email"/>
					      		<div class="tooltip-error" v-if="err.email">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	Ingresa tu email para continuar.
						      	</div>
						      	<div class="tooltip-error" v-if="err.email_msg">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	{{ err.email_msg }}
						      	</div>
							</div>
						</div>
						<div class="form-group">
							<label class="control-label col-sm-3" for="password">Contraseña*</label>
							<div class="col-sm-9">
								<input class="form-control" :class="{ 'has-error': err.password }" type="password" v-model="form1.password"/>
					      		<div class="tooltip-error" v-if="err.password">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	{{ err.password }}
						      	</div>
							</div>
						</div>
						<div class="form-group">
							<label class="control-label col-sm-3" for="password2">Confirmar contraseña*</label>
							<div class="col-sm-9">
								<input class="form-control" :class="{ 'has-error': err.password2 }" type="password" v-model="form1.password2"/>
					      		<div class="tooltip-error" v-if="err.password2">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	Confirma tu contraseña para continuar.
						      	</div>
							</div>
						</div>
				    <div class="col-sm-12">
				    	<div class="col-sm-offset-3 col-sm-9" style="padding-left: 10px;">
						    <div class="custom-checkbox">
						        <input type="checkbox" id="cb1" v-model="form1.is_wholesaler">
						        <label for="cb1">Registrarme como empresa</label>
					      	</div>
							<div class="custom-checkbox">
						        <input type="checkbox" id="suscribe" checked v-model="form1.subscribe">
						        <label for="suscribe">Suscribirme al newsletter de Lasddi</label>
						  	</div>
						  	<div class="custom-checkbox">
						        <input type="checkbox" id="terms" v-model="license">
						        <label for="terms">He leído y acepto
						        	<button type="button" class="btn text-gray-sm btn-modal no-margin no-padding" data-toggle="modal" data-target="#modal-terms-conditions">Términos y Condiciones</button>
						        	<modal-terms-conditions></modal-terms-conditions>
						        </label>
					        	<div class="tooltip-error-checkbox" v-if="error_msg">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	{{ error_msg }}
						      	</div>
						    </div>
					    </div>
				    <!--<div v-if="error_msg" class="col-sm-9 col-sm-offset-3 error"></div>-->
						<div class="col-sm-12 wholesaler" v-if="form1.is_wholesaler">
							<div class="form-group">
								<p class="col-sm-offset-3 col-sm-9 legend-custom">Información de la empresa
								</p>
							</div>
							<div class="form-group">
							    <label class="control-label col-sm-3" for="nombre_empresa">Nombre de la empresa*</label>
							    <div class="col-sm-9">
							    	<input type="text" class="form-control" :class="{ 'has-error': err.nombre_empresa }" v-model="form2.nombre_empresa"/>
								    <div class="tooltip-error-second" v-if="err.nombre_empresa">
								      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
								      	Ingresa el nombre de tu empresa para continuar.
							      	</div>
							    </div>
					 		</div>

					 		<div class="form-group">
							    <label class="control-label col-sm-3" for="nombre_representante">Nombre completo del representante*</label>
							    <div class="col-sm-9">
							    	<input type="text" class="form-control" :class="{ 'has-error': err.nombre_representante || err.nombre_representante_msg}" v-model="form2.nombre_representante"/>
								    <div class="tooltip-error-second" v-if="err.nombre_representante">
								      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
								      	Ingresa el nombre del representante de tu empresa para continuar.
							      	</div>
							      	<div class="tooltip-error-second" v-if="err.nombre_representante_msg">
								      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
								      	{{ err.nombre_representante_msg }}
							      	</div>
							    </div>
					 		</div>
					 		<div class="form-group">
							    <label class="control-label col-sm-3" for="tipo_negocio">Tipo de negocio*</label>
							    <div class="col-sm-9">
							    	<input type="text" class="form-control" :class="{ 'has-error': err.tipo_negocio || err.tipo_negocio_msg}" v-model="form2.tipo_negocio"/>
								    <div class="tooltip-error-second" v-if="err.tipo_negocio">
								      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
								      	Ingresa el tipo de negocio de tu empresa para continuar.
							      	</div>
							      	<div class="tooltip-error-second" v-if="err.tipo_negocio_msg">
								      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
								      	{{ err.tipo_negocio_msg }}
							      	</div>
							    </div>
					 		</div>

							<div class="form-group">
								<p class="col-sm-9 col-sm-offset-3 legend-custom">Datos de Facturación</p>
							</div>
							<div class="form-group">
								<label class="control-label col-sm-3" for="business_name">Nombre o razón social*</label>
								<div class="col-sm-9">
									<input type="text" class="form-control" :class="{ 'has-error': err.business_name }" v-model="form2.business_name"/>
					        		<div class="tooltip-error-second" v-if="err.business_name">
								      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
								      	Ingresa la razón social de tu empresa para continuar.
							      	</div>
				        		</div>
							</div>

							<div class="form-group">
							    <label class="control-label col-sm-3" for="rfc">RFC*</label>
							    <div class="col-sm-9">
						        	<input type="text" class="form-control" :class="{ 'has-error': err.rfc || err.rfc_msg}" v-model="form2.rfc"/>
								    <div class="tooltip-error-second" v-if="err.rfc">
								      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
								      	Ingresa el RFC de tu empresa para continuar.
							      	</div>
							      	<div class="tooltip-error-second" v-if="err.rfc_msg">
								      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
								      	{{ err.rfc_msg }}
							      	</div>
							    </div>
					 		</div>

							<div class="form-group">
								<label class="control-label col-sm-3" for="street">Calle*</label>
								<div class="col-sm-9">
									<input type="text" class="form-control" :class="{ 'has-error': err.street }" v-model="form2.street"/>
					        		<div class="tooltip-error-second" v-if="err.street">
								      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
								      	Ingresa la calle de tu empresa para continuar.
					        		</div>
						      	</div>
							</div>
							<div class="form-group">
								<label class="control-label col-sm-3" for="ext">N° Ext.*</label>
								<div class="col-sm-3">
									<input type="text" class="form-control" :class="{ 'has-error': err.ext_number }" v-model="form2.ext_number"/>
				        		</div>
				        		<label class="control-label col-sm-3" for="ext">N° Int.</label>
								<div class="col-sm-3">
									<input type="text" class="form-control" :class="{ 'has-error': err.int_number }" v-model="form2.int_number"/>
									<div class="tooltip-error-second" v-if="err.ext">
								      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
								      	Ingresa el número exterior de tu empresa para continuar.
					        		</div>
				        		</div>
							</div>

							<div class="form-group">
								<label class="control-label col-sm-3" for="suburb">Colonia*</label>
								<div class="col-sm-9">
									<input type="text" class="form-control" :class="{ 'has-error': err.suburb || err.suburb_msg}" v-model="form2.suburb"/>
				        			<div class="tooltip-error-second" v-if="err.suburb">
								      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
								      	Ingresa la colonia de tu empresa para continuar.
					        		</div>
					        		<div class="tooltip-error-second" v-if="err.suburb_msg">
								      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
								      	{{ err.suburb_msg }}
							      	</div>
						      	</div>
							</div>
							<div class="form-group">
								<label class="control-label col-sm-3" for="postal_code">C.P.*</label>
								<div class="col-sm-9">
									<input type="text" class="form-control" :class="{ 'has-error': err.postal_code || err.postal_code_msg}" v-model="form2.postal_code"/>
					        		<div class="tooltip-error-second" v-if="err.postal_code">
								      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
								      	Ingresa el código postal de tu empresa para continuar.
							      	</div>
							      	<div class="tooltip-error-second" v-if="err.postal_code_msg">
								      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
								      	{{ err.postal_code_msg }}
							      	</div>
				        		</div>
							</div>
							<div class="form-group">
								<label class="control-label col-sm-3" for="state">Estado*</label>
								<div class="col-sm-9">
									<div class="form-control control-select">
										<select class="select" :class="{ 'has-error': err.state }" v-model="form2.state" @change="addCities(form2.state)">
											<option value="" disabled selected>Selecciona un estado</option>
											<option v-for="state in render_states" :value="state.id">{{ state.nom_ent }}</option>
										</select>
										<i class="fa fa-caret-down select-caret"></i>
									</div>
					        		<div class="tooltip-error-second" v-if="err.state">
								      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
								      	Ingresa el estado de tu empresa para continuar.
					        		</div>
						      	</div>
							</div>
							<div class="form-group">
								<label class="control-label col-sm-3" for="city">Ciudad*</label>
								<div class="col-sm-9">
									<div class="form-control control-select">
										<select class="select" :class="{ 'has-error': err.city }" v-model="form2.city" id="city">
										  	<option value="" disabled selected>Seleccionar primero un estado</option>
										  	<option v-for="city in render_cities" :value="city.id">{{ city.nom_mun }}</option>
									  	</select>
									  	<i class="fa fa-caret-down select-caret"></i>
									</div>
					        		<div class="tooltip-error-second" v-if="err.city">
								      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
								      	Ingresa la ciudad de tu empresa para continuar.
					        		</div>
						      	</div>
							</div>
							<!-- <div class="form-group">
								<label class="control-label col-sm-3" for="country">País*</label>
								<div class="col-sm-9">
									<input type="text" class="form-control" :class="{ 'has-error': err.country || err.country_msg}" v-model="form2.country"/>
					        		<div class="tooltip-error-second" v-if="err.country">
								      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
								      	Ingresa el país de tu empresa para continuar.
					        		</div>
					        		<div class="tooltip-error-second" v-if="err.country_msg">
								      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
								      	{{ err.country_msg }}
							      	</div>
						      	</div>
							</div> -->
							<div class="form-group">
								<label class="control-label col-sm-3" for="phone_number">Teléfono*</label>
								<div class="col-sm-9">
									<input type="text" class="form-control" :class="{ 'has-error': err.phone_number || err.phone_number_msg}" v-model="form2.phone_number"/>
					        		<div class="tooltip-error-second" v-if="err.phone_number">
								      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
								      	Ingresa el número de teléfono de tu empresa para continuar.
					        		</div>
					        		<div class="tooltip-error-second" v-if="err.phone_number_msg">
								      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
								      	{{ err.phone_number_msg }}
							      	</div>
						      	</div>
							</div>
							<!-- <div class="form-group">
								<label class="control-label col-sm-3" for="email2">Email*</label>
								<div class="col-sm-9">
									<input type="text" class="form-control" :class="{ 'has-error': err.email2 || err.email2_msg}" v-model="form2.email2"/>
					        		<div class="tooltip-error-second" v-if="err.email2">
								      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
								      	Ingresa el email de tu empresa para continuar.
					        		</div>
					        		<div class="tooltip-error-second" v-if="err.email2_msg">
								      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
								      	{{ err.email2_msg }}
							      	</div>
						      	</div>
							</div> -->
						</div>

					    <div class="form-group">
						    <div class="col-sm-offset-3 col-sm-9">
						      <input type="submit" class="btn btn-black btn-lg" value="Registrarme"/>
						    </div>
					    </div>
					</form>
				</validator>
				</div>
			</div>
		</div>
	</div>
	<!-- TODO: check if the form is submited to show the loader. -->
	<loader-full v-if="is_submited"></loader-full>
</template>

<script>
import ModalTermsConditions from '../components/Modals/Modal-terms-conditions.vue';
import Card from '../components/Home/Card.vue';
import LoaderFull from '../components/Loader-full.vue';
import { router } from '../routes/routes';
import { createUser, addCities } from '../store/actions';
import { getDaysOfMonth } from '../scripts/bisiesto';

// ---- REGEX INFO ----
var string_regexp = new RegExp(/^[a-zA-Z0-9á-úÁ-Ú_ ]*$/);
var number_regexp = new RegExp(/^\d/);
var phone_regexp = new RegExp(/^\d{10}$/);
var email_regexp = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
var rfc_regexp = new RegExp(/^[A-Za-z]{3,4}\-{0,1}\d{6}(?:\-{0,1}[A-Za-z\d]{3})?$/);
var alphanumeric_regexp = new RegExp(/[^\s#°]+(\s+[^\s]+)*$/);
var postal_code_regexp = new RegExp(/^\d{5}$/);

// ---- GENERAL INFO ----

var form1 = {
	is_wholesaler: false,
	name: '',
	last_name: '',
	phone: '',
	// birthday: '',
	email: '',
	password: '',
	password2: '',
};

// ---- WHOLESALER INFO ----

var form2 = {
	// ---- COMPANY INFO ----

	nombre_empresa: '',
	nombre_representante: '',
	tipo_negocio: '',

	// ---- COMPANY VERIFICATION ----

	rfc: '',

	// ---- BILLING INFO ----

	business_name: '',
	street: '',
	ext_number: '',
	int_number: '',
	suburb: '',
	postal_code: '',
	city: '',
	state: '',
	// country: '',
	phone_number: '',
	// email2: ''
};

export default {
	// ---- DATA ----

	data() {
		return {
			form: {},
			form1: form1,
			form2: form2,
			license: false,
			has_error: false,
			error_msg: '',
			err: {},
			is_submited: false,
			month: null,
			day: null,
			days: null
		}
	},

	// ---- VUEX ----

	vuex: {
		getters: {
			states: state => state.states,
			cities: state => state.cities
		},
		actions: {
			createUser,
			addCities
		}
	},

	computed: {
		render_states() {
			return this.states;
		},

		render_cities () {
			return this.cities;
		}
	},

	// ---- COMPONENTS ----

	components: {
		Card,
		ModalTermsConditions,
		LoaderFull
	},

	// ---- METHODS ----

	methods: {
		getDays () {
			this.day = null;
			this.days = getDaysOfMonth(this.month - 1);
		},

		RegisterUser(e) {
			e.preventDefault();
			this.err = {};
			this.has_error = false;
			this.error_msg = '';
			this.form = {};

			for (var k in this.form1) {
				this.form[k] = this.form1[k];
			}
			/* Only validate general info. */
			if (this.form1.is_wholesaler) {
				for (var k in this.form2) {
					this.form[k] = this.form2[k];
				}

        // [Deprecated]
				// this.validateAll();
			}

      // [Deprecated]
			// this.validateGeneral();

			// Fix the tooltip.
			$(window).resize( function(){
				if ($(window).width()<778){
					setTimeout( function(){
						$(".tooltip-error").css({"position": "initial", "margin-top" : "20px"});
						//$("span>i").removeClass("fa-rotate-180");
						//$("span>i").addClass("fa-rotate-270");
						$(".top-caret").css({"display": "none"});
						$(".tooltip-error").addClass("center-block");
						//tooltip for checkbox
						$(".tooltip-error-checkbox").css({"position": "relative", "top": "-5px", "right": "0", "margin-top" : "5px", "margin-bottom" : "10px;"});
						$(".tooltip-error-checkbox").addClass("center-block");
						//tooltip for register as enterprise
						$(".tooltip-error-second").css({"position": "relative", "top": "-5px", "right": "0", "margin-top" : "20px"});
						$(".tooltip-error-second").addClass("center-block");
						//tooltip for no. ext
						$(".tooltip-error-custom").css({"position": "relative", "top": "-5px", "right": "0", "margin-top" : "20px"});
						$(".tooltip-error-custom").addClass("center-block");
					}, 10);
				}else{
					setTimeout( function(){
						$(".tooltip-error").css({"position": "absolute", "margin-top" : "0"});
						//$("span>i").removeClass("fa-rotate-180");
						//$("span>i").addClass("fa-rotate-270");
						$(".top-caret").css({"display": "block"});
						$(".tooltip-error").addClass("center-block");
						//tooltip for checkbox
						$(".tooltip-error-checkbox").css({"position": "absolute", "top": "55px", "right": "-215px", "margin-top" : "5px", "margin-bottom" : "10px;"});
						$(".tooltip-error-checkbox").addClass("center-block");
						//tooltip for register as enterprise
						$(".tooltip-error-second").css({"position": "absolute", "top": "0", "right": "-215px", "margin-top" : "0"});
						$(".tooltip-error-second").addClass("center-block");
						//tooltip for no. ext
						$(".tooltip-error-custom").css({"position": "absolute", "top": "0", "right": "-402px", "margin-top" : "0"});
						$(".tooltip-error-custom").addClass("center-block");
					}, 10);
				}
			});

      // [Deprecated] We don't validate anymore.
			// if (this.has_error) {
			// 	return;
			// }

			// add year in the birthday only for evade a validation.
			if (this.month && this.day) {
				this.form.birthday = '2016-' + this.month + '-' + this.day;
			} else {
				this.form.birthday = '';
			}

			this.transformWholesaler();
			this.is_submited = true;
			this.createUser(this.form, this);
			// e.target.reset();
		},

		transformWholesaler() {
			if (this.form.is_wholesaler) {
				this.form.is_wholesaler = 1;
			} else {
				this.form.is_wholesaler = 0;
			}
		},

		validateGeneral() {
			for (var k in this.form1) {
				if (!this.form1[k] && k != 'is_wholesaler' && k != 'subscribe') {
					this.err[k] = true;
					this.has_error = true;
				}
			}

			/*if (!this.month) {
				this.err.month = true;
				this.has_error = true;
			}

			if (!this.day) {
				this.err.day = true;
				this.has_error = true;
			}*/

			if (!this.form.name.match(string_regexp) && !this.err.name) {
				this.err.name_msg = 'Ingresa únicamente letras para continuar.';
				$(".col-sm-9").css("width", "55%");
			}

			if (!this.form.last_name.match(string_regexp) && !this.err.last_name){
				this.err.last_name_msg = 'Ingresa únicamente letras para continuar.';
			}

			if (!this.form.phone.match(phone_regexp) && !this.err.phone){
				this.err.phone_msg = 'Ingresa tu número a 10 dígitos para continuar.';
			}

			// if (!this.form.birthday.match(birthday_regexp) && !this.err.birthday){
			// 	this.err.birthday_msg = 'Ingresa tu fecha de cumpleaños para continuar.';
			// }
			// if (!this.form.birthday.match(birthday_regexp) && !this.err.birthday_month){
			// 	this.err.birthday_month_msg = 'Ingresa tu fecha de cumpleaños para continuar.';
			// }
			if (!this.form.email.match(email_regexp) && !this.err.email){
				this.err.email_msg = 'Ingresa un email válido para continuar.';
			}

			if (this.form.password.length < 8) {
				this.err.password = 'Tu contraseña debe tener al menos 8 caracteres.';
			}

			if (!this.form.password) {
				this.err.password = 'Ingresa tu contraseña para continuar';
			}

			if (this.form.password !== this.form.password2) {
				this.err.password2 = true;
				this.has_error = true;
				this.err.password = 'Tus contraseñas no coinciden.'
			}

			if (!this.license) {
				this.has_error = true;
				this.error_msg = 'Favor de leer y aceptar nuestros terminos y condiciones.';
			}
		},

		validateAll() {
			for (let k in this.form2) {
				if (!this.form2[k] && k != 'int_number') {
					this.err[k] = true;
					this.has_error = true;
				}
			}

			if (!this.form.nombre_representante.match(string_regexp) && !this.err.nombre_representante) {
				this.err.nombre_representante_msg = 'Ingresa únicamente letras para continuar.';
			}
			if (!this.form.tipo_negocio.match(alphanumeric_regexp) && !this.err.tipo_negocio) {
				this.err.tipo_negocio_msg = 'Ingresa únicamente letras y números para continuar.';
			}
			if (!this.form.rfc.match(rfc_regexp) && !this.err.rfc){
				this.err.rfc_msg = 'Ingresa un RFC válido (CUPU800825569).';
			}
			if (!this.form.ext_number.match(alphanumeric_regexp) && !this.err.ext){
				this.err.ext_msg = 'Ingresa únicamente letras y números para continuar.';
			}
			if (!this.form.suburb.match(string_regexp) && !this.err.suburb){
				this.err.suburb_msg = 'Ingresa únicamente letras para continuar.';
			}
			if (!this.form.postal_code.match(postal_code_regexp) && !this.err.postal_code){
				this.err.postal_code_msg = 'Ingresa un código postal válido.';
			}
			/*if (!this.form.city.match(string_regexp) && !this.err.city){
				this.err.city_msg = 'Ingresa únicamente letras para continuar.';
			}
			if (!this.form.state.match(string_regexp) && !this.err.state){
				this.err.state_msg = 'Ingresa únicamente letras para continuar.';
			}*/
			// if (!this.form.country.match(string_regexp) && !this.err.country){
			// 	this.err.country_msg = 'Ingresa únicamente letras para continuar.';
			// }
			if (!this.form.phone_number.match(phone_regexp) && !this.err.phone_number){
				this.err.phone_number_msg = 'Ingresa tu número a 10 dígitos para continuar.';
			}
			// if (!this.form.email2.match(email_regexp) && !this.err.email2){
			// 	this.err.email2_msg = 'Ingresa un email válido para continuar.';
			// }
		},

		isLogin() {
			let user = JSON.parse(localStorage.getItem('lasddi')) || {};
			// Check if the user is logged, and redirect to admin users.
			if (user.api_token) {
				router.go('/home');
			}
		}
	},

	// ---- READY ----

	ready: function() {
		// Init the tooltips.
		$('[data-toggle="tooltip"]').tooltip();
		this.days = getDaysOfMonth(0);

		this.isLogin();
	}
}
</script>



// WEBPACK FOOTER //
// Register.vue?081ec098